// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMenu as RawLucideMenu } from "lucide-react";
export const LucideMenu = /* @__PURE__ */ createIcon(RawLucideMenu, "LucideMenu", 2);
